export default __webpack_public_path__ + "static/media/IMG1828.80791871.jpg";